import React from 'react';
import {Redirect} from "react-router";

const HomePage = () => {
  return (
    <Redirect to="/l/default"/>
  );
}
export default HomePage;
